import React from 'react';
import styled from 'styled-components';
import { TextWithTooltip } from '../../TextWithTooltip';
import { font, ChartCell, ChartCellWrapper } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';
import type { CellTextAlign } from '../cellAlignment';

/** Match the name/index column's 12px edge inset for start/end-aligned text. */
const EDGE_PADDING = '12px';

const DefaultCellWrapper = styled.div<{ $align: CellTextAlign }>`
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: ${({ $align }) => $align};
  ${font}
  letter-spacing: -0.3px;
  padding-left: ${({ $align }) => ($align === 'left' ? EDGE_PADDING : '0')};
  padding-right: ${({ $align }) => ($align === 'right' ? EDGE_PADDING : '5px')};
`;

export const DefaultCellRenderer =
  (
    textAlign: CellTextAlign = 'center',
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
  ) =>
  // eslint-disable-next-line react/display-name
  ({ cellData, columnIndex }: any) => {
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);

    return (
      <ChartCell $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <ChartCellWrapper>
          <DefaultCellWrapper $align={textAlign}>
            <TextWithTooltip>{cellData}</TextWithTooltip>
          </DefaultCellWrapper>
        </ChartCellWrapper>
      </ChartCell>
    );
  };
